import DIApi from './_diApi';

class FixedAssetCategoryAPI extends DIApi {
  controllerName = 'FixedAssetCategorys';

  /**
   * Cập nhật lại misa_code_id để sắp xếp các loại TSCĐ
   * @returns 
   */
  async updateMisaCodeID(){
    const request = {
      url: [this.getAPIUrl(), 'UpdateMisaCodeID'].join('/'),
    };

    return await this.postAsync(request);
  }
}

export default new FixedAssetCategoryAPI();
